import {
  CARDIAC_IMPRESSION,
  CARDIAC_IVC_IMPRESSION,
  cardiacFindings,
} from "../groups/cardiac";
import { option, type UsWorksheetDefinition } from "../us-fields";

export const CARDIAC_INDICATIONS = [
  option("shortness_of_breath", "Shortness of breath"),
  option("chest_pain", "Chest pain"),
  option("cardiac_arrest", "Cardiac arrest"),
  option("edema", "Edema"),
  option("hypotension", "Hypotension"),
  option("syncope", "Syncope"),
  option("thoracic_trauma", "Thoracic trauma"),
  option("tachycardia", "Tachycardia"),
];

export const US_CARDIAC: UsWorksheetDefinition = {
  examType: "us_cardiac",
  version: 1,
  indications: CARDIAC_INDICATIONS,
  otherIndication: true,
  sections: [
    {
      id: "cardiac_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: cardiacFindings(),
    },
    {
      id: "cardiac_impression",
      label: "Impression",
      role: "impression",
      fields: [CARDIAC_IMPRESSION, CARDIAC_IVC_IMPRESSION],
    },
  ],
  normalImpressions: [
    {
      sectionId: "cardiac_impression",
      value: "normal_cardiac",
    },
  ],
  billing: {
    codes: [
      { cpt: "93308", label: "Echocardiography, limited", preTick: true },
    ],
  },
};
